<script>
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'

export default {
  components: { TheHeader, TheFooter },
}
</script>

<template>
  <div :class="[$style.layout]">
    <TheHeader class="header" />
    <slot />
    <TheFooter />
  </div>
</template>
<style lang="scss" module>
.layout {
  :global {
  }
}
</style>
